import { useCallback } from 'react';
import { Form } from 'react-bootstrap';
import cn from 'classnames';

interface TimeInputProps {
  value: number;
  onChange?: (value: number) => void;
  readOnly?: boolean;
  isTotal?: boolean;
  className?: string;
}

const TimeInput = ({
  value,
  onChange,
  readOnly = false,
  isTotal = false,
  className
}: TimeInputProps) => {
  const displayValue = value / 60;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!onChange) return;
      const raw = parseFloat(e.target.value);
      if (Number.isNaN(raw)) {
        onChange(0);
        return;
      }
      const rounded = Math.round(raw * 4) / 4;
      const clamped = Math.max(0, rounded);
      onChange(clamped * 60);
    },
    [onChange]
  );

  return (
    <Form.Control
      type='number'
      step={0.25}
      min={0}
      value={displayValue || ''}
      onChange={handleChange}
      readOnly={readOnly}
      disabled={readOnly}
      className={cn('cps-time-input', { 'is-total': isTotal }, className)}
      placeholder='0'
    />
  );
};

export { TimeInput };
